export default "__VITE_ASSET__CVU3nmHd__"